import Helper from '../helpers/Helper';

export default class Widgets {
    constructor() {
        this.el = null;
        this.wsh_id = null;
    }
    init(el) {
        if (el === undefined || el === null) {
            return;
        }
        if (el.querySelector('.wsh__container') === null) {
            return;
        }
        if (el.querySelector('.wsh__container').getAttribute('data-id') === null) {
            return;
        }
        this.el = el;
        this.wsh_id = this.el.querySelector('.wsh__container').getAttribute('data-id');
        this.loadScript('https://w.wsh.de/' + this.wsh_id + '.js', () => {
            window.wsh_loaded = true;
            // this can be multiple containers, because of slider--copy
            this.el.querySelectorAll('.wsh__container').forEach((container) => {
                container.innerHTML = `
                        <div data-wsh-wid="${this.wsh_id}">
                            <a
                                data-wsh-fb="${this.wsh_id}"
                                href="https://www.wirsindhandwerk.de/widget/${this.wsh_id}"
                                style="text-decoration: none"
                                target="_blank"
                                rel="noopener"
                            >
                                <img src="https://w.wsh.de/${this.wsh_id}.png"/>
                            </a>
                        </div>
                    `;
                if (typeof window.Wsh !== 'undefined') {
                    window.Wsh.init(container.children[0]);
                }
            });
            Helper.fixWshSvgs();
        });
    }

    loadScript(url, callback) {
        if (window.wsh_loaded === true) {
            callback();
            return;
        }
        let script = document.createElement('script');
        script.type = 'text/javascript';
        script.async = true;
        script.charset = 'utf-8';
        script.src = url;
        let entry = document.getElementsByTagName('script')[0];
        entry.parentNode.insertBefore(script, entry);
        if (script.addEventListener) {
            script.addEventListener('load', callback, false);
        } else {
            script.attachEvent('onreadystatechange', function() {
                if (/complete|loaded/.test(script.readyState)) callback();
            });
        }
    }
}
